<img #img [alt]="alt" class="object-cover object-center rounded-lg    aspect-square  grow  " [width]="size"
[height]="size"
 style="object-position: center;"
  loading="eager" [src]="url" fetchpriority="high" *ngIf="i==0" >


  <img #img [alt]="alt" class="object-cover object-center rounded-lg   aspect-square  grow  " [width]="size"
[height]="size"
 style="object-position: center;"
  loading="lazy" [src]="url"   *ngIf="i>0" >
